var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1190_25971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97933 1.85547C9.65903 1.85547 11.2699 2.52273 12.4577 3.71046C13.6454 4.89819 14.3127 6.5091 14.3127 8.1888C14.3127 9.86851 13.6454 11.4794 12.4577 12.6671C11.2699 13.8549 9.65903 14.5221 7.97933 14.5221C6.29962 14.5221 4.68872 13.8549 3.50099 12.6671C2.31326 11.4794 1.646 9.86851 1.646 8.1888C1.646 6.5091 2.31326 4.89819 3.50099 3.71046C4.68872 2.52273 6.29962 1.85547 7.97933 1.85547Z",
    fill: "#428600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97902 2.17516C6.38418 2.17516 4.85467 2.8087 3.72695 3.93642C2.59923 5.06414 1.96568 6.59365 1.96568 8.18849C1.96568 9.78333 2.59923 11.3128 3.72695 12.4406C4.85467 13.5683 6.38418 14.2018 7.97902 14.2018C9.57385 14.2018 11.1034 13.5683 12.2311 12.4406C13.3588 11.3128 13.9923 9.78333 13.9923 8.18849C13.9923 6.59365 13.3588 5.06414 12.2311 3.93642C11.1034 2.8087 9.57385 2.17516 7.97902 2.17516ZM3.2744 3.48387C4.52214 2.23613 6.21444 1.53516 7.97902 1.53516C9.74359 1.53516 11.4359 2.23613 12.6836 3.48387C13.9314 4.73161 14.6323 6.42392 14.6323 8.18849C14.6323 9.95306 13.9314 11.6454 12.6836 12.8931C11.4359 14.1408 9.74359 14.8418 7.97902 14.8418C6.21444 14.8418 4.52214 14.1408 3.2744 12.8931C2.02666 11.6454 1.32568 9.95306 1.32568 8.18849C1.32568 6.42392 2.02666 4.73161 3.2744 3.48387Z",
    fill: "#428600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.005 6.02537C11.13 6.15033 11.13 6.35295 11.005 6.47791L6.95123 10.5317L5.0239 8.60436C4.89893 8.47939 4.89893 8.27678 5.0239 8.15181C5.14887 8.02684 5.35148 8.02684 5.47645 8.15181L6.95123 9.62659L10.5525 6.02537C10.6774 5.9004 10.88 5.9004 11.005 6.02537Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1190_25971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.167969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.dbd6e5db3c0eb6a455f5ca627221bdc5.svg";
export { ForwardRef as ReactComponent };